import Header from '../components/Header';
import Hero from '../components/Hero';
import Brand from '../components/Brand';
import MisVis from '../components/MisVis';
import Step from '../components/Step';
import Blogc from '../components/Blogc';
import Footer from '../components/Footer';
import Chatbot from '../Chatbot';
import AboutUs from '../components/AboutUs';



export default function Home(){
          return(
                    <>
                    <Header />
                    <Hero />
                    <Brand />
                    <MisVis />
                    <Step />
                    <Blogc />
                    <Chatbot />
                    <AboutUs />
                    <Footer />
                    </>
          )
}